import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateBusySaving", function updateBusySaving(isSaving: boolean) {
    shiftEditorViewState().busySaving = isSaving;
});